import styled from "styled-components";
import { CenteredFlexRow } from "pro-features/styled components/StyledFlex/src/StyledFlex";
import { colorsPalettes } from "@similarweb/styles";

export const Tab = styled(CenteredFlexRow)`
    padding: 16px 24px;
    cursor: pointer;
    width: 100%;
    @media only screen and (max-width: 1280px) {
        padding: 16px 12px;
    }
    &.selected {
        border-bottom: 2px solid ${colorsPalettes.blue["400"]};
        z-index: 1;
        position: relative;
    }
`;
export const IconWrapper = styled(CenteredFlexRow)`
    border: 1px solid ${colorsPalettes.carbon["100"]};
    width: 22px;
    height: 22px;
    display: flex;
    box-sizing: border-box;
    border-radius: 6px;
    background: #ffffff;
    box-shadow: 0 2px 4px 0 rgb(202 202 202 / 20%);
    margin-right: 12px;
`;
export const TabWrapper = styled.li`
    &.tabs_5 {
        max-width: 20%;
    }
    &.tabs_4 {
        max-width: 25%;
    }
    &.tabs_3 {
        max-width: 33%;
    }
    &.tabs_2 {
        max-width: 50%;
    }
    > div {
        max-width: calc(100% - 48px);
        color: ${colorsPalettes.carbon["300"]};
        &.selected {
            color: ${colorsPalettes.blue["400"]};
        }
        @media only screen and (max-width: 1280px) {
            max-width: calc(100% - 24px);
        }
    }
`;
export const TextWrapper = styled.div`
    width: calc(100% - 34px);
    display: flex;
`;

export const NumberItem = styled(CenteredFlexRow)`
    font-weight: 700;
    font-size: 14px;
`;
export const TextItem = styled(CenteredFlexRow)<{ $reverseEllipsis?: boolean }>`
    font-weight: 700;
    font-size: 14px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    flex-shrink: 5;
    span {
        padding-right: 3px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        flex-shrink: 5;
        ${({ $reverseEllipsis }) => $reverseEllipsis && "direction: rtl;"}
    }
`;

export const CompareTabsWrapper = styled.div`
    width: 100%;
`;
export const DotsLoaderWrapper = styled.div`
    margin-left: 45px;
    margin-top: 7px;
`;
